const defaults = {
    confirmPending: true,
    relayRes: {},
    fetchRes: {
        code: 0,
        msg: '',
    },
    confirmLecture: null,
    confirmChannel: null,
    isPaySuccess: false,
    paySuccessRes: {},
}

export default (state = defaults, action) => {
    switch (action.type) {
        case 'RELAYCFM_INIT':
            return defaults
        case 'RELAYCFM_SET_PENDING':
            return { ...state, confirmPending: action.payload }
        case 'RELAYCFM_SET_RELAY_RES':
            return { ...state, relayRes: action.payload }
        case 'RELAYCFM_SET_LECTURE':
            return { ...state, confirmLecture: action.payload }
        case 'RELAYCFM_SET_CHANNEL':
            return { ...state, confirmChannel: action.payload }
        case 'RELAYCFM_SET_FETCH_RES':
            return { ...state, fetchRes: action.payload }
        case 'RELAYCFM_SET_IS_PAY_SUCCESS':
            return { ...state, isPaySuccess: action.payload }
        case 'RELAYCFM_SET_PAY_SUCCESS_RES':
            return { ...state, paySuccessRes: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/relayConfirm.js